module.exports = __webpack_public_path__ + "static/media/IDN.18b10785.svg";